import { useRef } from 'react'
import { TimePickerInput } from './time-picker-input'
import { cn } from '@/lib/utils'

interface Props {
  value: Date

  onBlur?(): void
  onChange(value: Date): void
}

export function TimePicker({
  value,

  onBlur,
  onChange,
}: Props) {
  const hoursRef = useRef<HTMLInputElement>(null)
  const minutesRef = useRef<HTMLInputElement>(null)

  return (
    <div
      className={cn(
        'inline-flex w-fit items-stretch',
        'focus-within:**:border-secondary'
      )}
    >
      <TimePickerInput
        ref={hoursRef}
        className="border-r-0 rounded-r-none pr-0"
        value={value}
        picker="hours"
        onRightFocus={() => minutesRef.current?.focus()}
        onBlur={onBlur}
        onChange={onChange}
      />

      <span className="inline-flex items-center border-y border-y-gray-200 px-1 transition-[border]">
        :
      </span>

      <TimePickerInput
        ref={minutesRef}
        className="border-l-0 rounded-l-none pl-0"
        value={value}
        picker="minutes"
        onLeftFocus={() => hoursRef.current?.focus()}
        onBlur={onBlur}
        onChange={onChange}
      />
    </div>
  )
}
